import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api.service';
import { DatePipe } from '@angular/common';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { Router } from '@angular/router';
import { checkDeliveryCalenderAndCutOffTime, displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted ));
  }
}
@Component({
  selector: 'app-skip-stop-recurring',
  templateUrl: './skip-stop-recurring.component.html',
  styleUrls: ['./skip-stop-recurring.component.scss']
})
export class SkipStopRecurringComponent implements OnInit {
  title;
  cutOffTime= [];
  limit = 25;
  displayedColumns = ['date', 'checkAvailability', 'action'];
  dataSource = new MatTableDataSource([]);
  url = this.router.url.split('?')[0];
  minRecurringStartDate: Date;
  minDate = new Date();
  minDayAfterNextDate = new Date(new Date().getTime()+(2*24*60*60*1000));
  start_date: Date;
  end_date: Date;
  vacationForm: FormGroup;
  isLoading = false;
  selectedDeliveryCalendar = {};
  yesButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Yes',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    customClass:'yesButton'
  }

  deleteButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Delete',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate'
  }
  skipButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Delete',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate'
  }
  matcher = new MyErrorStateMatcher();
  featureTags = {};
  dateFormat:string;
  constructor(@Inject(MAT_DIALOG_DATA) public product: any, 
  public dialogRef: MatDialogRef<SkipStopRecurringComponent>,
  private notification: NotificationService,
  private router: Router,
  private formBuilder: FormBuilder,
  private subscription: SubscriptionService,
  private apiService: ApiService, private datepipe: DatePipe,
  private dialog : MatDialog,
  public sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.vacationForm = this.formBuilder.group({
      // vacationDates: ['', Validators.required]
      start_date : ['', Validators.required],
      end_date : ['', Validators.required],
      comments: ['']
    });
    this.selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
    this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff')); 
    if(!!this.product['product'] && !!this.product['product']['delivery_date']) {
      this.minRecurringStartDate = this.product['product']['delivery_date']
    }
    if(this.product['value'] === 'cart recurring skip') {
      if(this.product['product']['isLastProduct'] ) {
        this.title = 'Cancel the Order';
        this.skipButtonOptions.text = "Yes";
      }else {
        this.title = 'Delete Product';
      }
    }
    if(this.product['value'] === 'skip') {
      this.getSingleRecurring();
    }
    if(this.product['value'] === 'stop') {
      if(this.product['product']['isLastProduct'] ) {
        this.title = 'Cancel the Order';
        this.deleteButtonOptions.text = "Yes";
      }else {
        this.title = 'Stop Delivery?';
        this.deleteButtonOptions.text = "Stop";
      }
    }
    if(this.product['value'] === 'recurring quantity update') {
      this.title = 'Recurring Quantity Update'
    }
    if(this.product['value'] === 'recurring frequency update') {
      this.title = 'Recurring Frequency Update'
    }
    if(this.product['value'] === 'cancel saleorder') {
      this.title = 'Cancel Sale Order'
    }
    if(this.product['value'] === 'skip saleorder') {
      this.title = 'Skip Sale Order'
    }
    if(this.product['value'] === 'confirm sale recurring delete') {
      this.title = 'Are you sure?'
    }
    if(this.product['value'] === 'confirm sale recurring product delete') {
      this.title = 'Are you sure?'
    }
    if(this.product['value'] === 'cancel scheduled order') {
      this.title = 'Cancel Scheduled Order'
    }
    if(this.product['value'] === 'confirm sale recurring product quantity') {
      this.title = 'Confirm Quantity Update'
    }
    if(this.product['value'] === 'add vacation dates') {
      this.dialogRef.disableClose = true;
      this.title = 'Add Vacation'
    }
    if(this.product['value'] === 'edit vacation dates') {
      this.dialogRef.disableClose = true;
      this.title = 'Edit Vacation'
      this.vacationForm.patchValue({
        start_date : this.product['data']['start_date'],
        end_date : this.product['data']['end_date'],
        comments: this.product['data']['comments']
      });
    }
    if(this.product['value'] === 'delete vacation dates') {
      this.dialogRef.disableClose = true;
      this.title = 'Delete Vacation'
      setTimeout(() => {
        const button = document.querySelector(".yesButton") as HTMLButtonElement;
        if (button) {
          button.blur();
        }
      }, 200);
    }
    if(this.product['value'] === 'vacation dates warning') {
      this.title = 'Invalid Start Date'
    }
    if(this.product['value'] === 'open order warning') {
      this.title = 'Change Start Date'
    }
  }
  getSingleRecurring(item: any = null) {
    this.isLoading = true;
    this.limit = !!item ? this.limit + item : 25;
    this.apiService.singleRecurring({limit : this.limit ,recurringId: !this.product['product']['skipped_delivery'] ? this.product['product']['id'] : this.product['product']['skipped_delivery']['recurring_item_id'] }).subscribe(data => {
      this.isLoading = false;
      if(data['response']['status'] === 1) {
        this.dataSource = data['response']['data']
      }
    });
  }
  unSkipRecurring(item: any = null) {
    let params = {
      type: 'unskipped',
      recurring_id:!this.product['product']['skipped_delivery'] ? this.product['product']['id'] : this.product['product']['skipped_delivery']['recurring_item_id'],
      skip_id: item['skip_id']
    }
    if(!!item) {
      item['load'] = true
    }
    this.apiService.unskipCartRecurring(params).subscribe(data => {
      if(!!item && data['response']['status'] === 1) {
        item['load'] = false
        this.getSingleRecurring();
        this.notification.success('Successfully Unskipped' , 5000);
      }      
      if(data['response']['status'] === 0) {
        this.notification.error(data['response']['message'], 5000)
      }else if(data['response']['status'] === 1 && !!item === false) {
        this.dialogRef.close({status: 1, msg: 'Unskip'});

      }else if(data['response'].status === 2 || data['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: data['response']
        });
      }else if(data['response']['status'] === 6) {
        this.notification.error(data['response']['message'], 5000)
      }
    }, error => {
      if(!!item) {
        item['load'] = false
      }    
    });
  }
  // DateFilter 
  deliveryDayFilter = (d: Date): boolean => {
    let deliveryDate = this.datepipe.transform(this.product['product']['delivery_date'], 'MM/dd/yyyy');
    let deliveryDay = new Date(deliveryDate).getDay();
    const day = d.getDay();
    return day === deliveryDay;
  }

  saveDates() {
    let values = {
      id: this.product['product']['id'],
      type : 'skipped',
      start_date : this.datepipe.transform(this.start_date, 'MM/dd/yyyy'), 
	    end_date : this.datepipe.transform(this.end_date, 'MM/dd/yyyy')
    }
    this.dialogRef.close({status: 1, data:values});
  }

  deleteRecurring(isDeleteAll: boolean = false) {

    this.deleteButtonOptions.active = true;
    this.yesButtonOptions.active = true;
    if(this.product['product']['isLastProduct'] &&  !checkDeliveryCalenderAndCutOffTime()) {
      this.deleteScheduledOrder();
    }
    let values = {
      id: this.product['product']['id'],
      type : 'deleted'
    }
    if (isDeleteAll) {
      values['open_order'] = 1;
    }else{
      values['open_order'] = 0;
    }
    if(this.product['product']['sale_order_id']  || checkDeliveryCalenderAndCutOffTime()) {      
      values['id'] = this.product['product']['id'];
    }
    if(this.product['product']['skipped_delivery']) {
      values['id'] = this.product['product']['skipped_delivery']['recurring_item_id']
    }
    this.apiService.deleteRecurring(values).subscribe(data => {
      this.deleteButtonOptions.active = false;
      this.yesButtonOptions.active = false;
      if(data['response']['status'] === 0) {
        this.notification.error(data['response']['message'], 5000)
      }else if(data['response']['status'] === 1) {
        this.dialogRef.close({status: 1, data,  message : 1, deleted : 1});
        this.notification.success("Successfully removed", 5000)
      }else if(data['response']['status'] === 2) {
        this.notification.warning(data['response']['message'], 5000)
      }else if(data['response']['status'] === 3) {
        let errors = Object.entries(data['response'].data.errors);
        let errMsgLength = Object.keys(data['response'].data.message).length;
        let message = '';
        errors.forEach((err , i) => {
          let comma = (errMsgLength-1) !== i ? ", ":'';
          message += data['response'].data.message[err[0]][0]+ comma;
        });
        this.notification.warning('Validation Error - '+message)
      }else if(data['response']['status'] === 6) {
        this.notification.error(data['response']['message'], 5000)
      }
    });
    
  }

  cartRecurringSkip(item: any = null) {
    this.skipButtonOptions.active = true;
    if(!this.product['product']['isLastProduct'] || (this.product['product']['isLastProduct'] && checkDeliveryCalenderAndCutOffTime()) ) {
      var data = {
        id: !this.product['product']['skipped_delivery'] ? this.product['product']['id'] : this.product['product']['skipped_delivery']['recurring_item_id'],
        type : 'skipped',
        "start_date" : this.product['value'] === 'skip'?  this.datepipe.transform(item['delivery_date'], 'MM/dd/yyyy') :this.datepipe.transform(this.product['product']['recurring_date'], 'MM/dd/yyyy'), 
        "end_date" : this.product['value'] === 'skip' ?  this.datepipe.transform(item['delivery_date'], 'MM/dd/yyyy') :this.datepipe.transform(this.product['product']['recurring_date'], 'MM/dd/yyyy')
      }
      if(this.product['product']['saleId'] || this.product['saleId']) {
        data['id'] = this.product['product']['recurringId']
      }
      if(!!item) {
        item['load'] = true
      }      
      this.apiService.skipCartRecurring(data).subscribe(result => {
        if(!!item && result['response']['status'] === 1 ) {
          item['load'] = false;
          this.getSingleRecurring(this.limit);
          this.notification.success('Successfully Skipped' , 5000);
        }        
        this.skipButtonOptions.active = false;
        if(result['response']['status'] === 1 && !!item === false) {
          this.dialogRef.close({status: 1});
        }
      }, (error) => {
        this.skipButtonOptions.active = false;
        if(!!item) {
          item['load'] = false
        } 
        if(error) {
          console.log(error);
        }
      });
      if(this.product['product']['saleId'] || this.product['saleId']) {
        var values = {
          sale_product_id: this.product['product']['saleId']
        }
        this.deleteSaleProduct(values);
      }
      if(this.product['product']['cartId']) {
        var value = {
          cart_product_id: this.product['product']['cartId'],
        }
        this.apiService.deleteCart(value).subscribe(result => {
          this.skipButtonOptions.active = false;
          if(result['response']['status'] === 1) {
  
          }
        }, (error) => {
          this.skipButtonOptions.active = false;
          if(error) {
            console.log(error);
          }
        });
      }
    }
    if(this.product['product']['isLastProduct'] && !checkDeliveryCalenderAndCutOffTime()) {
      this.deleteScheduledOrder();
    }
    
  }

  recurringQuantityUpdate() {
    let data = {
      recurring_id: this.product['product']['id'],
      quantity: this.product['fieldValue']
    }
    this.dialogRef.close({status: 1, data:data});
  }

  recurringFrequencyUpdate() {
    this.yesButtonOptions.active = true;
    let values = {
      recurring_id: this.product['product']['id'],
      frequency: this.product['fieldValue'],
      recurring_start_date: this.datepipe.transform(this.start_date, 'MM/dd/yyyy')
    }
    this.apiService.updateRecurring(values).subscribe(data => {
      this.yesButtonOptions.active = false;
      if(data['response']['status'] === 0) {
        this.notification.error(data['response']['message'], 5000)
      }else if(data['response']['status'] === 1) {
        this.dialogRef.close({status: 1, data:data});
        this.notification.success("Successfully updated", 5000)
      }else if(data['response']['status'] === 2) {
        this.notification.warning(data['response']['message'], 5000)
      }else if(data['response']['status'] === 3) {
        let errors = Object.entries(data['response'].data.errors);
        let errMsgLength = Object.keys(data['response'].data.message).length;
        let message = '';
        errors.forEach((err , i) => {
            let comma = (errMsgLength-1) !== i ? ", ":'';
            message += data['response'].data.message[err[0]][0]+ comma;
        });
        this.notification.warning('Validation Error - '+message)
      }else if(data['response']['status'] === 6) {
        this.notification.error(data['response']['message'], 5000)
      }
    });
  }

  cancelSaleOrder() {
    this.dialogRef.close({status: 1});
  }
  deleteSaleProduct(values) {
    this.apiService.deleteSaleProduct(values).subscribe(result => {
      this.deleteButtonOptions.active = false;
      this.skipButtonOptions.active = false;
      this.yesButtonOptions.active = false;
      if(result['response']['status'] === 1) {
        this.dialogRef.close({value: 'delete', product: this.product, status: 1, message : 1, deleted : 1});
      } else {
        // this.notification.warning(result['response']['message'], 5000);
      }
    }, (error) => {
      this.skipButtonOptions.active = false;
      this.deleteButtonOptions.active = false;
      this.yesButtonOptions.active = false;
      if(error) {
        console.log(error);
      }
    });
  }
  deleteSaleRecurringProduct() {
    // this.dialogRef.close({message: 'delete'});
    this.deleteRecurring();
  }
  deleteScheduledOrder() {
    var values = {};
    this.yesButtonOptions.active = true;
    values = Array.isArray(this.product['product']) ? this.product['product'].map(val =>({
      recurring_id: val['id'],
      product_id: val['product']['id'],  
      quantity: val['quantity'],  
      frequency: val['frequency'], 
      is_recurring: 1
    })) : [{
      recurring_id: this.product['product']['id'],
      product_id: this.product['product']['product']['id'],  
      quantity: this.product['product']['quantity'],  
      frequency: this.product['product']['frequency'], 
      is_recurring: 1
    }]
    this.apiService.cancelScheduledOrder({items: values}).subscribe(result => {
      this.skipButtonOptions.active = false;
      this.deleteButtonOptions.active = false;
      this.yesButtonOptions.active = false;
      if(result['response']['status'] === 1) {
        this.subscription.subjectNext({msg:"set delivery calendar order status", status: "cancelled"});
        this.dialogRef.close({message: 'delete scheduled order', deleted:1 , status:1});
      }
    });
  }
  close() {
    this.dialogRef.close();
  }
  saveVacationDates() {
    if(this.vacationForm.invalid) {
      return;
    }
    this.yesButtonOptions.active = true;
    this.vacationForm.value['start_date'] = this.datepipe.transform(this.vacationForm.value['start_date'], 'MM/dd/yyyy')
    this.vacationForm.value['end_date'] = this.datepipe.transform(this.vacationForm.value['end_date'], 'MM/dd/yyyy')
    var data = {
      start_date : this.vacationForm.value['start_date'],
      end_date : this.vacationForm.value['end_date']
    }
    this.apiService.checkOrderForVacationDelete(data).subscribe(res =>{      
      if (res['response']['status'] === 1) {
        this.dialogRef.close('close');

        const dialogRef = this.dialog.open(PopupComponent, {
          width : '450px',
          data : { 
            msg : 'sale order delete alert',
            dates : res['response']['data'],
          },
          autoFocus: false,
        });
        dialogRef.afterClosed().subscribe(result => {          
          if(!!result && result['status'] === 1) {
            this.apiService.addVacationDates(this.vacationForm.value).subscribe(res => {              
              if(res['response'].status === 1) {
                this.dialogRef.close({status:1});
                this.sharedDataService.vacationUpdate$.next(true);
                this.notification.success(res['response'].message, 5000);
              } else if(res['response'].status === 2 || res['response'].status === 3) {
                displayErrorMessage({
                  notification: this.notification, 
                  response: res['response']
                });
              } else {
                this.notification.error(res['response'].message, 5000);
              }
            });
          }
        });
      }else{
        this.apiService.addVacationDates(this.vacationForm.value).subscribe(res => {          
          if(res['response'].status === 1) {
            this.dialogRef.close({status:1});
            this.sharedDataService.vacationUpdate$.next(true);
            this.notification.success(res['response'].message, 5000);
          } else if(res['response'].status === 2 || res['response'].status === 3) {
            displayErrorMessage({
              notification: this.notification, 
              response: res['response']
            });
          } else {
            this.notification.error(res['response'].message, 5000);
          }
        });
      }
    });
  }
  editVactionDates() {
    if(this.vacationForm.invalid) {
      return;
    }
    this.yesButtonOptions.active = true;
    this.vacationForm.value['start_date'] = this.datepipe.transform(this.vacationForm.value['start_date'], 'MM/dd/yyyy')
    this.vacationForm.value['end_date'] = this.datepipe.transform(this.vacationForm.value['end_date'], 'MM/dd/yyyy')
    this.vacationForm.value['vacationId'] = this.product['data']['id']
    var data = {
      start_date : this.vacationForm.value['start_date'],
      end_date : this.vacationForm.value['end_date']
    }
    this.apiService.checkOrderForVacationDelete(data).subscribe(res =>{      
      if (res['response']['status'] === 1) {
        this.dialogRef.close('close');

        const dialogRef = this.dialog.open(PopupComponent, {
          width : '450px',
          data : { 
            msg : 'sale order delete alert',
            dates : res['response']['data'],
          },
          autoFocus: false,
        });
        dialogRef.afterClosed().subscribe(result => {          
          if(!!result && result['status'] === 1) {
            this.apiService.editVacationDates(this.vacationForm.value).subscribe(res => {
              this.yesButtonOptions.active = false;
              if(res['response'].status === 1) {
                this.dialogRef.close({status:1});
                this.sharedDataService.vacationUpdate$.next(true);
                this.notification.success(res['response'].message, 5000);
              } else if(res['response'].status === 2 || res['response'].status === 3) {
                displayErrorMessage({
                  notification: this.notification, 
                  response: res['response']
                });
              } else {
                this.notification.error(res['response'].message, 5000);
              }
            });
          }
        })
      }else{
        this.apiService.editVacationDates(this.vacationForm.value).subscribe(res => {
          this.yesButtonOptions.active = false;
          if(res['response'].status === 1) {
            this.dialogRef.close({status:1});
            this.sharedDataService.vacationUpdate$.next(true);
            this.notification.success(res['response'].message, 5000);
          } else if(res['response'].status === 2 || res['response'].status === 3) {
            displayErrorMessage({
              notification: this.notification, 
              response: res['response']
            });
          } else {
            this.notification.error(res['response'].message, 5000);
          }
        });
      }
    });
  }
  cancelVacationDates() {
    this.yesButtonOptions.active = true;
    this.vacationForm.value['vacationId'] = this.product['data']['id']
    this.apiService.cancelVacationDates(this.vacationForm.value).subscribe(res => {
      this.yesButtonOptions.active = false;
      if(res['response'].status === 1) {
        this.dialogRef.close({status:1});
        this.notification.success(res['response'].message, 5000);
      } else if(res['response'].status === 2 || res['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: res['response']
        });
      } else {
        this.notification.error(res['response'].message, 5000);
      }
    });
  }

  updateSaleOrder(){
    this.dialogRef.close({status: 1});
  }
  closeSaleOrder(){
    this.dialogRef.close({status: 0});
  }
  navigateToVacationDates(){
    this.dialogRef.close({status: 1});
  }
  deleteRecerringItem(){
    this.dialogRef.close({status: 1});
  }
  updateQtyRecurringItem(){
    this.dialogRef.close({status: 1});
  }
}
